import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';
import { AnalyticsSite, AnalyticsFlow } from '../types';

/**
 * Track clicks to "bulk discount" card in Signup: Recipes: How It Works.
 * Supports Default Plan Frequency experiment.
 * notion.so/thefarmersdog/1d755d8e446d8086b5a7cfade5060072?pvs=4
 */
export function trackRecipesClickHowItWorks() {
  track(segmentTrackEvents.clicked, {
    site: AnalyticsSite.Main,
    module_name: 'how it works',
    flow: AnalyticsFlow.Signup,
  });
}
